(function ($) {
  // Task 14: run carousel init after the browser has had a chance to paint the hero (LCP),
  // instead of inside the DOMContentLoaded burst. rAF -> setTimeout = "after the next frame".
  // Fallback timer covers background tabs where rAF does not fire.
  function afterPaint(fn) {
    var done = false;
    function run() { if (!done) { done = true; fn(); } }
    requestAnimationFrame(function () { setTimeout(run, 0); });
    setTimeout(run, 1000);
  }

  function initBanners() {
    $('.HomeBannerCarouel').each(function () {
      var $carousel = $(this);
      // The stage/items are rendered in sections/banners.liquid, so Owl skips replace() and never
      // moves the hero <img>. On that path Owl does not add .owl-loaded itself.
      $carousel
        .on('initialized.owl.carousel', function () {
          $carousel.addClass('owl-loaded');
        })
        .owlCarousel({
          loop: false,
          rewind: true,
          margin: 15,
          nav: true,
          dots: false,
          autoplay: true,
          navText: ['<span class="left"></span>', '<span class="right"></span>'],
          responsive: {
            0: { items: 1 },
            600: { items: 1 },
            1000: { items: 1 },
          },
        });
    });
  }

  $(function () {
    afterPaint(initBanners);
  });
})(jQuery);
